import Instance from '../../../utils/Axios';

const HistoricoMensal = (id, dataInicio, dataFim) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .get(`/obras/${id}/historico/${dataInicio}/${dataFim}`)
      .then(({ data }) => {
        dispatch({ type: 'GET_HISTORICO_MENSAL', payload: data.yData });
      })
      .catch(({ err }) => console.log(err));
  }
};

export default HistoricoMensal;
